<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap pb-0">
            <section class="client-section pb-0">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>
        </div>
        <div class="client-content-wrap">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <v-img src="/images/business/domestic/job/process-list.png" alt="" class="d-md-none" />

                    <div class="d-none d-md-block">
                        <v-row class="process-list row--lg">
                            <v-col v-for="(item, index) in process" :key="index" cols="12" lg="3">
                                <v-card color="#FAFAFA" flat class="process-card">
                                    <v-row class="text-center">
                                        <v-col cols="12">
                                            <v-img :src="`/images/business/domestic/job/process-${index + 1}.svg`" max-width="80" class="mb-24 mx-auto" />
                                            <!-- <div class="primary--text font-weight-bold font-size-28">0{{ index + 1 }}</div> -->
                                            <div v-html="item.name" class="tit tit--sm primary--text mt-16" />
                                            <div v-html="item.text" class="page-text page-text--lg mt-16" />
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </section>

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <program-list :items="programs" />
                </v-container>
            </section>
        </div>
        <section>
            <bottom-banner :item="banner" />
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ProgramList from "@/components/client/business/program-list.vue";
import BottomBanner from "@/components/client/business/bottom-banner.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ProgramList,
        BottomBanner,
        ScrolldownTail,
    },
    data() {
        return {
            visual: {
                sh: "국내복지사업",
                tabActive: "일자리 창출사업",
                text: "우리는 단순한 지원을 넘어, 지속 가능한 변화를 만들어 갑니다.",
                bg: "/images/business/domestic/visual.jpg",
                mobile: "/images/business/domestic/mobile-visual.jpg",
            },
            intro: {
                image: "/images/business/domestic/job/intro.jpg",
                title: "더 나은 내일을 위한 첫걸음",
                texts: "일자리창출사업은 개인의 역량 강화와 자립을 지원하며, <br class='d-none d-xl-block' />지역사회 내 일자리 창출을 통해 경제적 안정과 삶의 질 향상을 도모합니다. <br class='d-none d-xl-block' />구직자와 구인자 모두를 위한 맞춤형 서비스를 제공하여 지속 가능한 경제활동을 지원합니다.",
            },
            process: [
                {
                    name: "취업역량 강화",
                    text: "개인별 직업 역량 개발을 통해 <br class='d-none d-xl-block' />성공적인 취업을 지원합니다",
                },
                {
                    name: "지속 가능한 일자리 창출",
                    text: "지역사회와 협력하여 <br class='d-none d-xl-block' />다양한 일자리를 발굴하고 <br class='d-none d-xl-block' />제공합니다",
                },
                {
                    name: "경제적 자립지원",
                    text: "취약계층의 경제적 자립을 위한 <br class='d-none d-xl-block' />체계적인 교육과 지원을 <br class='d-none d-xl-block' />실시합니다",
                },
                {
                    name: "기업과 구직자 연결",
                    text: "구직자와 기업 간의 <br class='d-none d-xl-block' />매칭을 지원하여 <br class='d-none d-xl-block' />양질의 고용을 창출합니다",
                },
            ],
            programs: [
                {
                    image: "/images/business/domestic/job/program-1.jpg",
                    title: "취업지원 서비스",
                    texts: [
                        "구직 상담 및 취업 정보 제공",
                        "이력서 및 자기소개서 작성법, 면접 스킬 교육",
                        "취업 성공 사례 공유 및 멘토링 프로그램 운영",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/job/program-2.jpg",
                    title: "직업훈련 프로그램",
                    texts: [
                        "전문 직업 교육을 통해 직무 능력을 강화",
                        "디지털 역량 강화 교육 및 자격증 취득 지원",
                        "산업 수요에 맞는 맞춤형 직업훈련 과정 제공",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/job/program-3.jpg",
                    title: "일자리 발굴 및 매칭 서비스",
                    texts: [
                        "지역사회 내 기업과 협력하여 새로운 일자리 발굴",
                        "구직자와 구인자의 요구에 맞춘 맞춤형 매칭 서비스 제공",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/job/program-4.jpg",
                    title: "사회적 기업 및 창업 지원",
                    texts: [
                        "창업 희망자를 위한 전문 컨설팅 및 교육 제공",
                        "사회적 경제와 연계한 일자리 창출 사업 지원",
                        "초기 창업자 대상 재정적·행정적 지원 프로그램 운영",
                        //
                    ],
                },
                {
                    image: "/images/business/domestic/job/program-5.jpg",
                    title: "취약계층 및 맞춤형 일자리 지원",
                    texts: [
                        "저소득층, 경력단절 여성, 청년, 장애인 등을 위한 맞춤형 일자리 지원",
                        "지속 가능한 고용 환경 조성을 위한 워크숍 및 간담회 개최",
                        //
                    ],
                },
            ],
            banner: {
                image: "/images/business/domestic/job/bottom-banner.jpg",
                mobile: "/images/business/domestic/job/bottom.jpg",
                white: true,
            },
        };
    },
};
</script>

<style lang="scss" scoped>
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 14px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/legacy/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
}
</style>